// @flow
import React, { type Node, useMemo } from 'react';
import cn from 'classnames/bind';

import SimpleDate from 'app/dataProviders/SimpleDate';
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link';

import styles from './DnevnikHeader.scss';


const headerFormat = 'MMMM, YYYY';
const emptyFunc = () => {};
const cx = cn.bind(styles);

type Props = {
  day: SimpleDate,
  onPrevWeek: null | () => void,
  onNextWeek: null | () => void,
}

const DnevnikHeader = ({ day, onPrevWeek, onNextWeek }: Props): Node => {
  const [weekStartDate, weekFinDate] = useMemo(() => {
    if (!day.getIsValid()) return ['', ''];
    const momentDay = day.createMoment();
    const mDay = !momentDay.day() ? momentDay.day(-1) : momentDay;
    const start = mDay.day(1).format(headerFormat);
    const final = mDay.day(6).format(headerFormat);
    return [start, final];
  }, [day]);

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.header}>
            <PlainButtonAsLink
              linkClassName={cx(styles.arrow, styles.left, { disabled: !onPrevWeek })}
              onClick={onPrevWeek || emptyFunc}
              disabled={!onPrevWeek}
            >
              <span className="visuallyHidden">Предыдущая неделя</span>
              &larr;
            </PlainButtonAsLink>
            {weekStartDate}
          </th>

          <th className={styles.header}>
            {weekFinDate}
            <PlainButtonAsLink
              linkClassName={cx(styles.arrow, styles.right, { disabled: !onNextWeek })}
              onClick={onNextWeek || emptyFunc}
              disabled={!onNextWeek}
            >
              <span className="visuallyHidden">Следующая неделя</span>
              &rarr;
            </PlainButtonAsLink>
          </th>
        </tr>
      </thead>
    </table>
  );
};

export default DnevnikHeader;
